module.exports = __webpack_public_path__ + "static/media/logo_esn_small_en.f69ff2f8.svg";